import React from 'react';
import { Box, Flex } from '@chakra-ui/react';

import { MainPageContent } from '../../common/components/MainPageContent';
import MainPageHeading from '../../common/components/MainPageHeading/MainPageHeading';
import { useTranslations } from '../../contexts/LocalizationContext';
import { useRestaurantsWithReturnCodesCount, useReturnCodesForRestaurant } from '../../services/return-codes';
import { ReturnCodesCreateModal } from './components/ReturnCodesCreate/ReturnCodesCreateModal';
import { ReturnCodesCreatedModal } from './components/ReturnCodesCreated/ReturnCodesCreatedModal';
import { ReturnCodesManageModal } from './components/ReturnCodesManage/ReturnCodesManageModal';
import { ReturnCodesMediumTable } from './components/ReturnCodesTable/ReturnCodesMediumTable';
import { ReturnCodesMobileTable } from './components/ReturnCodesTable/ReturnCodesMobileTable';
import { ReturnCodesTable } from './components/ReturnCodesTable/ReturnCodesTable';
import { ReturnCodesTableHeading } from './components/ReturnCodesTableHeading/ReturnCodesTableHeading';
import { ReturnCodesTableMediumHeading } from './components/ReturnCodesTableHeading/ReturnCodesTableMediumHeading';
import { ReturnCodesTableMobileHeading } from './components/ReturnCodesTableHeading/ReturnCodesTableMobileHeading';
import { useReturnCodesContext } from './context/hooks/useReturnCodesContext';
import { RETURN_CODES_DEFAULT_TABLE_LIMIT } from './ReturnCodes.consts';

export const ReturnCodes = () => {
  const translations = useTranslations();

  const { returnCodesState } = useReturnCodesContext();

  const {
    data: locationsData,
    isFetching: isLocationsDataFetching,
    refetch: refetchLocations,
  } = useRestaurantsWithReturnCodesCount(
    {
      searchLocationText: returnCodesState.searchLocation,
      cityIds: returnCodesState.selectedCities,
      locationWithIssueType: returnCodesState.selectedLocationWithIssueType,
      returnCodeAge: returnCodesState.selectedReturnCodeAgeType,
    },
    returnCodesState.page,
    RETURN_CODES_DEFAULT_TABLE_LIMIT,
  );

  const {
    data: returnCodesData,
    isFetching: isReturnCodesDataFetching,
    refetch: refetchReturnCodes,
  } = useReturnCodesForRestaurant(returnCodesState.locationIdToManage as string);

  return (
    <MainPageContent>
      <MainPageHeading>{translations('return_codes_heading')}</MainPageHeading>
      <ReturnCodesTableHeading display={['none', 'none', 'none', 'none', 'block']}></ReturnCodesTableHeading>
      <ReturnCodesTableMediumHeading
        display={['none', 'none', 'block', 'block', 'none']}
      ></ReturnCodesTableMediumHeading>
      <ReturnCodesTableMobileHeading
        display={['block', 'block', 'none', 'none', 'none']}
      ></ReturnCodesTableMobileHeading>
      <Flex width="100%">
        <Box display={['none', 'none', 'none', 'none', 'block']} width="100%">
          <ReturnCodesTable data={locationsData} isFetching={isLocationsDataFetching}></ReturnCodesTable>
        </Box>
        <Box display={['none', 'none', 'block', 'block', 'none']} width="100%">
          <ReturnCodesMediumTable data={locationsData} isFetching={isLocationsDataFetching}></ReturnCodesMediumTable>
        </Box>
        <Box display={['block', 'block', 'none', 'none', 'none']} width="100%">
          <ReturnCodesMobileTable data={locationsData} isFetching={isLocationsDataFetching}></ReturnCodesMobileTable>
        </Box>
      </Flex>

      <ReturnCodesManageModal
        refetchLocations={refetchLocations}
        isReturnCodesDataFetching={isReturnCodesDataFetching}
        refetchReturnCodes={refetchReturnCodes}
        returnCodesData={returnCodesData}
      ></ReturnCodesManageModal>
      <ReturnCodesCreateModal
        refetchLocations={refetchLocations}
        refetchReturnCodes={refetchReturnCodes}
      ></ReturnCodesCreateModal>
      <ReturnCodesCreatedModal></ReturnCodesCreatedModal>
    </MainPageContent>
  );
};
